import { Button } from "@ui/button";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from "@ui/menubar";
import { SVG } from "@components/items/common/SVG";
import { MenuIcon } from "@components/icons/MenuIcon";
import { PersonIcon } from "@components/icons/PersonIcon";
import { SettingsIcon } from "@components/icons/SettingsIcon";
import TranslatedText from "@components/items/display/TranslatedText";
import { signOut } from "@lib/stores";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { Language } from "@modules/localizations/i18n";
import { HelpIcon } from "@components/icons/HelpIcon";
import { useLanguage } from "@modules/localizations/LanguageContext";

const UserMenu = ({
  isB2bAllowed,
  isB2cAllowed,
  isB2b,
  onB2bChange,
  language,
  onLanguageToggle,
}: {
  isB2bAllowed?: boolean;
  isB2cAllowed?: boolean;
  isB2b?: boolean;
  onB2bChange?: () => void | Promise<void>;
  language?: Language;
  onLanguageToggle?: () => void;
}) => {
  const navigate = useAppNavigate();

  const { direction } = useLanguage();

  // TODO: Recheck all
  // const { theme, setTheme } = useTheme();
  // const { subType, setSubType } = useContext(SubscriptionContext);

  return (
    <Menubar className="border-none" dir={direction}>
      <MenubarMenu>
        <MenubarTrigger
          asChild
          className="cursor-pointer rounded-none focus:bg-transparent focus-visible:ring-0 data-[state=open]:bg-transparent"
        >
          <Button
            variant="basic"
            className="gap-x-10 text-black dark:text-white"
          >
            <MenuIcon width={34} height={6} />
          </Button>
        </MenubarTrigger>
        <MenubarContent
          sideOffset={25}
          align="end"
          className="bg-white text-[#898A8D] dark:bg-black"
        >
          {!isB2b ? (
            <MenubarItem
              inset={true}
              className="group cursor-pointer"
              onSelect={() => {
                navigate("/settings", {
                  tab: "profile",
                });
              }}
            >
              <div className="flex items-center justify-start gap-x-2">
                <PersonIcon width={15} height={15} />
                <TranslatedText text={`layout.${"profile"}`} />
              </div>
            </MenubarItem>
          ) : null}
          <MenubarItem
            inset={true}
            className="group cursor-pointer"
            onSelect={() => {
              navigate("/settings", {
                tab: "account",
              });
            }}
          >
            <div className="flex items-center justify-start gap-x-2">
              <SettingsIcon width={19} height={19} />
              <TranslatedText text={`layout.${"settings"}`} />
            </div>
          </MenubarItem>
          {language === "ar" ? (
            <MenubarItem
              inset={true}
              className="group cursor-pointer"
              onSelect={() => navigate("/help-center")}
            >
              <div className="flex items-center justify-start gap-x-2">
                <HelpIcon width={20} height={19} />
                <TranslatedText text={`layout.${"help-center"}`} />
              </div>
            </MenubarItem>
          ) : null}
          {/* TODO */}
          {/* <MenubarItem
            className="flex items-center justify-between"
            onSelect={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="flex items-center justify-start gap-2">
              <SVG src="/assets/b2b/icons/night-mode.svg" />
              <TranslatedText text={`layout.${"dark-mode"}`} />
            </div>

            <div
              onClick={(e) => {
                e.stopPropagation();
                // theme == 'dark' ? setTheme('light') : setTheme('dark');
              }}
            >
              <BasicSwitch
                checked={theme == 'dark'}
                onCheckedChange={() => {
                  theme == 'dark' ? setTheme('light') : setTheme('dark');
                }}
              />
            </div>
          </MenubarItem>
          <MenubarSeparator /> */}
          <div className="w-full py-1"></div>
          {isB2bAllowed && !isB2b ? (
            <MenubarItem
              inset={true}
              className="group cursor-pointer"
              onSelect={async () => {
                onB2bChange && (await onB2bChange());
              }}
            >
              <div className="flex items-center justify-start gap-x-2">
                <TranslatedText text={`layout.${"B2B"}`} />
              </div>
            </MenubarItem>
          ) : null}
          {isB2cAllowed && isB2b ? (
            <MenubarItem
              inset={true}
              className="group cursor-pointer"
              onSelect={async () => {
                onB2bChange && (await onB2bChange());
              }}
            >
              <div className="flex items-center justify-start gap-x-2">
                <TranslatedText text={`layout.${"B2C"}`} />
              </div>
            </MenubarItem>
          ) : null}
          {isB2bAllowed ? (
            <MenubarItem
              inset={true}
              className="group cursor-pointer"
              onSelect={() => {
                onLanguageToggle && onLanguageToggle();
              }}
            >
              <div className="flex items-center justify-start gap-x-2">
                <TranslatedText
                  text={`layout.${language === "ar" ? "en" : "ar"}`}
                />
              </div>
            </MenubarItem>
          ) : null}
          {/* ************************** */}
          <div className="w-full py-1"></div>
          {/* ********************* */}
          <MenubarItem
            inset={true}
            className="group cursor-pointer"
            onClick={() => {
              signOut();
            }}
          >
            <div className="flex items-center justify-start gap-x-2">
              <SVG src="/assets/b2b/icons/logout.svg" />
              <TranslatedText text={`layout.${"logout"}`} />
            </div>
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
};

export default UserMenu;
